// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #eee;
}

.analytics-header h1 {
  color: #333;
  font-size: 1.8rem;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.summary-card {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  text-align: center;
}

.summary-card h3 {
  color: #666;
  font-size: 0.9rem;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.summary-value {
  font-size: 2rem;
  font-weight: bold;
  color: #007bff;
}

.no-responses {
  text-align: center;
  padding: 4rem 2rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.no-responses p {
  color: #666;
  font-size: 1.1rem;
}

.questions-analytics {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.question-analytics {
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #eee;
}

.question-analytics:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.question-analytics h3 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.required-badge {
  background: #ffc107;
  color: #000;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

.text-responses {
  max-height: 400px;
  overflow-y: auto;
}

.text-response-item {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 0.75rem;
}

.response-number {
  font-weight: bold;
  color: #666;
  display: block;
  margin-bottom: 0.5rem;
}

.text-response-item p {
  color: #333;
  margin: 0;
}

.chart-container {
  margin-bottom: 1rem;
}

.chart-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.rating-analytics {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.rating-summary {
  text-align: center;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.rating-summary h4 {
  color: #333;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyAnalytics.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;AACX","sourcesContent":[".analytics-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.analytics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #eee;\n}\n\n.analytics-header h1 {\n  color: #333;\n  font-size: 1.8rem;\n}\n\n.summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.summary-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  text-align: center;\n}\n\n.summary-card h3 {\n  color: #666;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  margin-bottom: 0.5rem;\n}\n\n.summary-value {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #007bff;\n}\n\n.no-responses {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.no-responses p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.questions-analytics {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.question-analytics {\n  margin-bottom: 3rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #eee;\n}\n\n.question-analytics:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.question-analytics h3 {\n  color: #333;\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.required-badge {\n  background: #ffc107;\n  color: #000;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n}\n\n.text-responses {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.text-response-item {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 0.75rem;\n}\n\n.response-number {\n  font-weight: bold;\n  color: #666;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.text-response-item p {\n  color: #333;\n  margin: 0;\n}\n\n.chart-container {\n  margin-bottom: 1rem;\n}\n\n.chart-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.legend-color {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n}\n\n.rating-analytics {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.rating-summary {\n  text-align: center;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n}\n\n.rating-summary h4 {\n  color: #333;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
